import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Index from './Pages/Index';
import About from './Pages/About';
import Experts from './Pages/Experts';
import ExpertsDtl from './Pages/ExpertsDtl';
import Login from './Pages/Login';
import Otp from './Pages/Otp';
import Allexperts from './Pages/Allexperts';
import Community from './Pages/Community';
import CommunityCity from './Pages/CommunityCity';
import CommunityBooking from './Pages/CommunityBooking';
import CommunityDtl from './Pages/CommunityDtl';
import CommunityJoin from './Pages/CommunityJoin';
import Meetups from './Pages/Meetups';
import MeetupsDtl from './Pages/MeetupsDtl';
import Destinations from './Pages/Destinations';
import DestinationsDtl from './Pages/DestinationsDtl';
import Blog from './Pages/Blog';
import BlogDtl from './Pages/BlogDtl';
import CookiePolicy from './Pages/CookiePolicy';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsOfservice from './Pages/TermsOfservice';
import Faq from './Pages/Faq';
import CustomizedTrips from './Pages/CustomizedTrips';
import CustomizedTripsDtl from './Pages/CustomizedTripsDtl';
import GroupTrips from './Pages/GroupTrips';
import GroupTripsDtl from './Pages/GroupTripsDtl';
import Profile from './Pages/Profile';
import Help from './Pages/Help';
import ExperienceTrips from './Pages/ExperienceTrips';
import ExperienceTripsDtl from './Pages/ExperienceTripsDtl';
import DestinationsDetail from './Pages/DestinationsDetail';
import HomeBannerAbout from './Components/HomeBannerAbout';
import Notifications from './Pages/Notifications';

function App() {
  return (
    <Router>
    <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<Login />} />
          <Route path="/Experts" element={<Experts/>} />
          <Route path="/ExpertsDtl" element={<ExpertsDtl/>} />
          <Route path="/Otp" element={<Otp/>} />
          <Route path="/Allexperts" element={<Allexperts/>} />
          <Route path="/Community" element={<Community/>} />
          <Route path="/CommunityCity" element={<CommunityCity/>} />
		      <Route path="/CommunityBooking" element={<CommunityBooking/>} />
          <Route path="/CommunityDtl/:id" element={<CommunityDtl/>} />
          <Route path="/CommunityJoin/:id" element={<CommunityJoin/>} />
          <Route path="/Meetups" element={<Meetups/>} />
          <Route path="/MeetupsDtl/:city" element={<MeetupsDtl />} />
          <Route path="/Destinations" element={<Destinations/>} />
          <Route path="/DestinationsDtl" element={<DestinationsDtl/>} />
          <Route path="/Blog" element={<Blog/>} />
          <Route path="/BlogDtl" element={<BlogDtl/>} />
          <Route path="/CookiePolicy" element={<CookiePolicy/>} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy/>} />
          <Route path="/TermsOfservice" element={<TermsOfservice/>} />
          <Route path="/Faq" element={<Faq/>} />
          <Route path="/CustomizedTrips" element={<CustomizedTrips/>} />
          <Route path="/CustomizedTripsDtl/:type/:id" element={<CustomizedTripsDtl/>} />
          <Route path="/GroupTrips" element={<GroupTrips/>} />
          <Route path="/GroupTripsDtl/:id" element={<GroupTripsDtl/>} />
          <Route path="/Profile" element={<Profile/>} />
          <Route path="/ExperienceTrips" element={<ExperienceTrips />} /> 
          <Route path="/ExperienceTripsDtl/:id" element={<ExperienceTripsDtl />} />
          <Route path="/DestinationsDetail/:city" element={<DestinationsDetail />} />
          <Route path="/HomeBannerAbout" element={<HomeBannerAbout />} />
		      <Route path="/Notifications" element={<Notifications />} />
          <Route path="/Help" element={<Help />} />

        {/* ✅ 404 Route - Always Last */}
        <Route path="*" element={<Notifications />} />
      </Routes>
    </Router>
  );
}

export default App;
